import { OverlayContainer } from '@angular/cdk/overlay';
import { Injectable } from '@angular/core';

/**
 * Kontejner plovoucích vrstev CDK (rozbalovací menu, našeptávače, potvrzení, dialogy,
 * zásuvky, notifikace) zavěšený pod `<html>`, ne do `<body>`.
 *
 * ⚠ Tmavý motiv invertuje `<body>` filtrem a `filter` na předkovi dělá z prvku kotvu
 * pro `position: fixed`. Kontejner je `position: fixed`, takže se v tmavém motivu
 * neukotvil v okně, ale v rolovatelném obsahu těla — a odjel s ním. Potvrzení smazání
 * bloku v článku se tak otevřelo 5 779 px nad oknem a koš „nic nedělal" (EL-2271):
 * CDK sice záporný posun kontejneru k výchozímu bodu přičte, ale test „vejde se do
 * okna" a přitlačení dělá v souřadnicích okna, takže panel přitlačí na spodní okraj
 * kontejneru — a ten je mimo obraz. Totéž postihlo zásuvky, dialogy i notifikace.
 *
 * Stejnou cestou už šla prohlížečka obrázků (EL-2117) a zvětšená scéna (EL-2243):
 * co má být ukotvené v okně, visí pod `<html>`, mimo filtrované tělo. Inverzi si
 * kontejner v tmavém motivu dostává sám (`styles/_theme-dark.scss`) a písmo z motivu
 * (`theme.less`) — z `<body>` už nic nedědí.
 */
@Injectable()
export class HtmlOverlayContainerService extends OverlayContainer {

  protected override _createContainer(): void {
    super._createContainer();
    // CDK ho pověsil do <body>; přesun je totéž, co dělá jeho FullscreenOverlayContainer
    // při přechodu do celoobrazovkového režimu. Od CDK 21 je pole volitelné; po
    // super._createContainer() existuje vždy.
    this._document.documentElement.appendChild(this._containerElement!);
  }
}
